<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowRequirementRelateAuditForm" :model="formData" class="full-width-input" :disable="readOnly"
             :rules="rules" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="需求主题" prop="RequirementRelate.subjectName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.RequirementRelate.subjectName"
                      :clearable="true" placeholder="需求主题"
            />
            <span class="input-item input-label" v-else>{{formData.RequirementRelate.subjectName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="对接专家" prop="RequirementRelate.specialistId">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.RequirementRelate.specialistId" :clearable="true" filterable
                       placeholder="对接专家" :loading="flowRequirementRelateAuditForm.specialistId.impl.loading"
                       @visible-change="flowRequirementRelateAuditForm.specialistId.impl.onVisibleChange"
                       @change="onSpecialistIdValueChange">
              <el-option v-for="item in flowRequirementRelateAuditForm.specialistId.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.RequirementRelate.specialistIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form v-if="formData2" ref="flowRequirementForm" :model="formData2" class="full-width-input" :disable="readOnly"
             style="width: 100%;"
             label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">

        <el-col :span="12">
          <el-form-item label="需求主体名称" prop="Requirement.mainBody">
            <span class="input-item input-label" >{{formData2.Requirement.mainBody}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体联系人" prop="Requirement.mainContact">
            <span class="input-item input-label" >{{formData2.Requirement.mainContact}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体手机" prop="Requirement.mainPhone">
            <span class="input-item input-label" >{{formData2.Requirement.mainPhone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="座机" prop="Requirement.landline">
            <span class="input-item input-label" >{{formData2.Requirement.landline}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="Requirement.eMail">
            <span class="input-item input-label" >{{formData2.Requirement.eMail}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="Requirement.industryId">
            <span class="input-item input-label" >{{(formData2.Requirement.industryIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="需求类型" prop="Requirement.subjectType">
            <span class="input-item input-label">{{(formData2.Requirement.subjectTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区" prop="Requirement.areaId">
            <span class="input-item input-label" >{{(formData2.Requirement.areaIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="Requirement.address">
            <span class="input-item input-label" >{{formData2.Requirement.address}}</span>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="需求主题" prop="Requirement.subjectName">-->
<!--            <span class="input-item input-label" >{{formData2.Requirement.subjectName}}</span>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12">
          <el-form-item label="关键词" prop="Requirement.keyWord">
            <span class="input-item input-label" >{{formData2.Requirement.keyWord}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="需求描述" prop="Requirement.requirementDesc">
            <span class="input-item input-label" >{{formData2.Requirement.requirementDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" prop="Requirement.validity">
            <span class="input-item input-label" >{{(formData2.Requirement.validityDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否公开" prop="Requirement.isOpen">
            <span class="input-item input-label" >{{(formData2.Requirement.isOpenDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="附件照片" prop="Requirement.attachedImages">
            <template >
              <img v-for="item in flowRequirementForm.attachedImages.impl.fileList" :key="item.url"
                   class="table-cell-image" :src="item.url" />
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { RequirementRelateController, DictionaryController ,RequirementController} from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowRequirementRelateAudit';

export default {
  name: 'flowRequirementRelateAuditForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      formData2: {
        Requirement: {

        }
      },
      formData: {
        RequirementRelate: {
          id: undefined,
          createTime: undefined,
          requirementId: undefined,
          specialistId: undefined,
          specialistName: undefined,
          auditStatus: undefined,
          subjectName: undefined,
          isDatasourceInit: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      rules: {
        'RequirementRelate.subjectName': [
          {required: true, message: '请输入需求主题', trigger: 'blur'}
        ]
      },
      flowRequirementRelateAuditForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        specialistId: {
          impl: new DropdownWidget(this.loadSpecialistIdDropdownList)
        },
        isInit: false
      },
      flowRequirementForm: {
        formFilter: {
        },
        formFilterCopy: {

        },
        attachedImages: {
          impl: new UploadWidget(5)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowRequirementRelateAuditForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return RequirementRelateController.startAndTakeUserTaskFlowRequirementRelateAudit(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              requirementRelateDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList) {
      return new Promise((resolve, reject) => {
        this.$refs.flowRequirementRelateAuditForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.requirementRelateDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return RequirementRelateController.submitUserTaskFlowRequirementRelateAudit(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          requirementRelateDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        RequirementRelateController.startAndSaveDraftFlowRequirementRelateAudit(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.RequirementRelate
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.RequirementRelate[item.variableName];
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      let that = this
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? RequirementRelateController.viewTaskBusinessDataFlowRequirementRelateAudit(this, params) : RequirementRelateController.viewHistoricTaskBusinessDataFlowRequirementRelateAudit(this, params)
        }
        httpCall.then(res => {
          this.formData.RequirementRelate = { ...res.data };
          this.flowRequirementRelateAuditForm.specialistId.impl.onVisibleChange(true).catch(e => {});

          // 获取一对多、多对多数据
          this.refreshFlowRequirementRelateAuditForm(true);

          let params = {id: this.formData.RequirementRelate.requirementId}

          RequirementController.view(this, params, null, {showMask: false}).then(data => {
            that.formData2.Requirement = data.data

            let attachedImagesDownloadParams = {
              id: that.formData2.Requirement.id,
              fieldName: 'attachedImages',
              asImage: true
            }
            that.flowRequirementForm.attachedImages.impl.fileList = that.parseUploadData(that.formData2.Requirement.attachedImages, attachedImagesDownloadParams);
          })
        }).catch(e => {});
      } else {
        // 启动流程

      }
      // alert(JSON.stringify(this.formData.RequirementRelate))
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
       * 对接专家下拉数据获取函数
       */
    loadSpecialistIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialist(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 对接专家选中值改变
       */
    onSpecialistIdValueChange (value) {
    },
    /**
       * 更新需求对接审核表单
       */
    refreshFlowRequirementRelateAuditForm (reloadData = false) {
      if (!this.flowRequirementRelateAuditForm.isInit) {
        // 初始化下拉数据
      }
      this.flowRequirementRelateAuditForm.isInit = true;
    },
    formInit () {
      this.initFormData();
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
